import { ADD_LOCATION_IDS, LOCATION_SELECTED, RESET_LOCATION, UPDATE_LOCATION_DATA } from "./actionTypes";

const INIT_STATE = {
  selectedLocationId: "",
  locationIds: [],
};

const LocationManagement = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOCATION_SELECTED:
      return {
        ...state,
        selectedLocationId: action.payload,
      };

    // case UPDATE_LOCATION_DATA:
    //   return {
    //     ...state,
    //     locationData: action.payload,
    //   };

    case ADD_LOCATION_IDS:
      return {
        ...state,
        locationIds: action.payload,
      };

    case RESET_LOCATION:
      return {
        selectedLocationId: "",
        locationIds: [],
      };

    default:
      return state;
  }
};

export default LocationManagement;
